<template>
 
  <viewAnotatedForm
  :formsesid="formsesid"
  templatebasedon="study">

  </viewAnotatedForm>
</template>

<script src="./viewAnotatedForm.js"></script>

